import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, flowTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupState = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: flowTypes.StateLookupDataType): AxiosPromise<flowTypes.StateLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.flow.lookupState), {
    blockSpinner,
  });
};

export const stateAdd = (
  form: flowTypes.StateCreateDataType,
  options: { blockErrorHandler: boolean },
): AxiosPromise<flowTypes.StateCreateResultType> => {
  return axios.post(urlsConfig.flow.stateAdd, form, options);
};

export const stateAllAdd = (
  form: flowTypes.StateCreateDataType[],
  options: { blockErrorHandler: boolean },
): AxiosPromise<flowTypes.StateCreateResultType> => {
  return axios.patch(urlsConfig.flow.stateAllAdd, form, options);
};

export const stateEdit = (
  form: flowTypes.StateEditDataType,
  // formData: FormData,
): AxiosPromise<flowTypes.StateResultType> => {
  // if (form.id !== undefined) {
  //   formData.append('id', form.id);
  // }

  // if (form.stateName) {
  //   formData.append('stateName', form.stateName);
  // }

  // if (form.color) {
  //   formData.append('color', form.color);
  // }

  // if (form.flowChartType) {
  //   formData.append('flowChartType', form.flowChartType);
  // }
  return axios.patch(urlsConfig.flow.stateEdit, form, { blockErrorHandler: true });
};

export const stateDelete = ({ id }: flowTypes.StateDeleteDataType): AxiosPromise<flowTypes.StateDeleteResultType> => {
  return axios.delete(`${urlsConfig.flow.stateDelete}/${id}`);
};
